import { LIST_USER_EDITS, LIST_ALL_EDITS } from '../actions/edit'
import { UPDATE_COMMENTS } from '../actions/comments'

const initialState = {
	userEdits: [],
	allEdits: []
}

export default function editReducer(state=initialState, action) {
	if(action.type === LIST_USER_EDITS) {
		return Object.assign({}, state, { userEdits: action.edits })
	}
	if(action.type === LIST_ALL_EDITS) {
		return Object.assign({}, state, { allEdits: action.edits })
	}
	if(action.type === UPDATE_COMMENTS) {
		const userEdits = state.userEdits.map(edit => {
			if(edit._id === action.update._id) {
				return action.update
			}
			return edit
		})
		return Object.assign({}, state, { userEdits })
	}
	return state
}


// WEBPACK FOOTER //
// ./src/reducers/edit.js